module.exports = __webpack_public_path__ + "img/customer.284ccb92.png";